var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerPlug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 12C22.3023 12 22.75 12.4478 22.75 13C22.75 13.5522 22.3023 14 21.75 14H21C18.6539 14.0027 16.7528 15.9041 16.75 18.25V19C16.75 21.7615 14.5114 24 11.75 24C8.98857 24 6.75 21.7615 6.75 19V17.2319C6.75031 17.1077 6.6591 17.002 6.536 16.9839C5.79811 16.8777 5.25032 16.2456 5.25 15.5V13.759C5.25015 13.655 5.18607 13.562 5.089 13.5249C2.75891 12.6946 1.21558 10.4734 1.25 8V5C1.25 4.17163 1.92157 3.5 2.75 3.5H3.5C3.63808 3.5 3.75 3.38818 3.75 3.25V1C3.75 0.447754 4.19771 0 4.75 0C5.30229 0 5.75 0.447754 5.75 1V3.25C5.75 3.38818 5.86192 3.5 6 3.5H9.5C9.63808 3.5 9.75 3.38818 9.75 3.25V1C9.75 0.447754 10.1977 0 10.75 0C11.3023 0 11.75 0.447754 11.75 1V3.25C11.75 3.38818 11.8619 3.5 12 3.5H12.75C13.5784 3.5 14.25 4.17163 14.25 5V8C14.2849 10.4739 12.7414 12.6956 10.411 13.5259C10.3139 13.563 10.2498 13.656 10.25 13.76V15.5C10.2502 16.2458 9.70226 16.8787 8.964 16.9851C8.84113 17.0034 8.75012 17.1086 8.75 17.2329V19C8.75 20.6567 10.0931 22 11.75 22C13.4069 22 14.75 20.6567 14.75 19V18.25C14.7539 14.7998 17.5498 12.0039 21 12H21.75ZM9.75 7.75C10.1642 7.75 10.5 7.41431 10.5 7C10.5 6.58569 10.1642 6.25 9.75 6.25H5.75C5.33578 6.25 5 6.58569 5 7C5 7.41431 5.33578 7.75 5.75 7.75H9.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerPlug);
export default __webpack_public_path__ + "static/media/powerPlug.ff75d4c5.svg";
export { ForwardRef as ReactComponent };